export const CHURCH = {
    name: "Greater Mount Olive AME Church",
    shortName: "Greater Mount Olive AME",
    address: "439 N. 50th Street, Philadelphia, PA 19139",
    phone: "215-473-1747",
    phoneHref: "tel:+12154731747",
    email: "greatermountoliveamec@outlook.com",
    emailHref: "mailto:greatermountoliveamec@outlook.com",
    pastor: "Rev. Marlo Woods, M.Div.",
    giveUrl: "https://secure.qgiv.com/for/greatermountolive/",
    watchLiveUrl: "#watch-live",
    streamUrl: "#watch-live",
    mapEmbedUrl:
        "https://www.google.com/maps?q=439+N+50th+Street,+Philadelphia,+PA+19139&output=embed",
    mapLinkUrl:
        "https://www.google.com/maps/dir/?api=1&destination=439+N+50th+Street,+Philadelphia,+PA+19139",
    services: [
        { label: "Sunday Worship", time: "11:00 AM" },
        { label: "Sunday School", time: "10:00 AM" },
        { label: "Prayer Meeting & Bible Study", time: "Tuesdays · 6 – 8 PM" },
    ],
    social: {
        facebook: "https://facebook.com/",
        instagram: "https://instagram.com/",
        youtube: "https://youtube.com/",
        twitter: "https://twitter.com/",
    },
    prayer: {
        dailyTime: "Daily · 6 – 9 AM",
        dailyDialIn: "1-503-300-6877",
        dailyCode: "753034",
        callLines: [
            { day: "Tuesdays", time: "6 – 7 PM", dialIn: "1-206-307-0277", code: "793174" },
        ],
    },
    stats: [
        { number: "200+", label: "Years of Faith" },
        { number: "500+", label: "Meals Served Monthly" },
        { number: "10", label: "Active Ministries" },
        { number: "5K+", label: "Lives Touched" },
    ],
};

// ALL imagery hand-picked from Pexels — explicitly tagged Black / African American / Afro-American
// or from the African gospel collection.
const px = (id, w = 1600) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=${w}`;

// Real church-supplied photos — all hosted locally in /public/photos/
const PASTOR_PULPIT = "/photos/pastor-pulpit.jpg";
const PASTOR_PORTRAIT = "/photos/pastor-portrait.jpg";
const YPD_KIDS = "/photos/ypd-kids.jpg";
const BAPTISM = "/photos/baptism.jpg";
const PASTOR_PARK = "/photos/pastor-park.jpg";
const PASTOR_POLICE = "/photos/pastor-police.jpg";

// Reel-only photos (added to the home page marquee until specified elsewhere)
const REEL_GOLD_VESTMENT = "/photos/gold-cross.jpg"; // Gold/silver embroidered cross on vestment fabric
const REEL_ADVENT = "/photos/chrystal.jpg"; // Chrystal — member portrait
const REEL_CHAPLAIN_AWARD = "/photos/chaplain-award.jpg";
const REEL_ADVENT_CANDLE = "/photos/advent-candle.jpg"; // Advent candle lighting ceremony (compressed)
const REEL_DANCERS = "/photos/lay-org.jpg"; // Lay Organization — members in white worshipping with arms raised (compressed)
const REEL_BIBLE = "/photos/bible.jpg"; // open Bible (Exodus)
const REEL_YPD_PASTOR = "/photos/ypd-pastor.jpg"; // YPD green sashes — adult+girl pointing up
const REEL_CHRISTMAS_KIDS = "/photos/christmas-kids.jpg"; // four girls at Merry Christmas photo booth
const REEL_FOOD_OUTDOOR = "/photos/food-distribution.jpg"; // outdoor food distribution (compressed)
const REEL_FOOD_PANTRY = REEL_FOOD_OUTDOOR; // alias — real food pantry photo
const REEL_SCHOOL_KIDS = "/photos/school-kids.jpg"; // first day of school 2025 chalkboards
const STEWARDS_ADVANTAGE = "https://customer-assets.emergentagent.com/job_olive-worship/artifacts/7d3ntrwe_image.png"; // The Steward's Advantage Account flyer
const CHURCH_EXTERIOR = "/photos/church-exterior.jpg"; // Greater Mount Olive AME exterior — 439 N. 50th Street
const WMS_PHOTO = "/photos/wms.jpg"; // Women's Missionary Society — two members in white with regal hats
const SHE_AME_LOGO = "https://customer-assets.emergentagent.com/job_olive-worship/artifacts/uj15f8cq_She%20AME.jpg"; // She AME official ministry logo
const AME_LOGO = "https://customer-assets.emergentagent.com/job_olive-worship/artifacts/y9a7v50y_image.png"; // Official AME shield logo (cross + anvil)

// Volunteer ministry gallery — real church outreach in action
const VOLUNTEER_TEAM = "/photos/volunteer-team.jpg";
const VOLUNTEER_FOOD = "/photos/volunteer-food-tables.jpg";
const VOLUNTEER_HUG = "/photos/volunteer-hug.jpg";
const VOLUNTEER_CIRCLE = "/photos/volunteer-circle.jpg";
const HOME_FOOD_PANTRY = "/photos/home-food-pantry.jpg";

export const REAL_PHOTOS = { PASTOR_PULPIT, PASTOR_PORTRAIT, YPD_KIDS, BAPTISM, PASTOR_PARK, PASTOR_POLICE, REEL_GOLD_VESTMENT, REEL_ADVENT, REEL_CHAPLAIN_AWARD, REEL_FOOD_PANTRY, REEL_DANCERS, REEL_BIBLE, REEL_YPD_PASTOR, REEL_CHRISTMAS_KIDS, REEL_FOOD_OUTDOOR, REEL_SCHOOL_KIDS, STEWARDS_ADVANTAGE, CHURCH_EXTERIOR, WMS_PHOTO, AME_LOGO };

export const MEDIA = {
    // Hero: Afro-American gospel choir joyfully singing in sunlit church
    hero: px(7520361),
    heroAlt: px(34770978),
    // Real pastor photos
    pastor: PASTOR_PULPIT,
    pastorAlt: PASTOR_PORTRAIT,
    pastorFemale: PASTOR_PULPIT,
    pastorLeading: PASTOR_PULPIT,
    pastorReading: PASTOR_PORTRAIT,
    pastorPrayer: PASTOR_PULPIT,
    pastorBible: PASTOR_PULPIT,
    minister: PASTOR_PORTRAIT,
    suited: px(13172188),
    // Worship & congregation
    choir: px(7520074),
    choir2: px(7520355),
    choir3: px(7520361),
    worship: px(34770978),
    worship2: px(7520074),
    sermon: PASTOR_PULPIT,
    family: px(9577188),
    family2: px(9577193),
    pews: px(7520749),
    congregation: px(7520775),
    prayer: px(7218331),
    reading: px(7218329),
    african: px(30550589),
    volunteer1: px(6647032),
    // Modern church exterior
    location: "https://images.unsplash.com/photo-1761477104708-b1c0281e698c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjaHVyY2glMjBleHRlcmlvciUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODA1MTM3NjB8MA&ixlib=rb-4.1.0&q=85",
};

export const MINISTRIES = [
    { id: "youth", name: "Youth Ministry YPD", tagline: "Sundays · 10 AM Sunday School", description: "Engaging programs, mentorship, and fellowship for children, teens, and young adults of Greater Mount Olive.", image: YPD_KIDS },
    { id: "outreach", name: "Food Pantry", tagline: "Wednesdays · 9 – 11:30 AM", description: "Feeding our neighbors in West Philadelphia. Open weekly behind the church. Call (215) 473-1747 for details.", image: REEL_FOOD_OUTDOOR },
    { id: "volunteer", name: "Volunteer", tagline: "Serve. Lead. Grow.", description: "Plug into the heartbeat of the church — from greeters to outreach to media.", image: VOLUNTEER_TEAM, gallery: [VOLUNTEER_TEAM, VOLUNTEER_HUG, VOLUNTEER_FOOD, VOLUNTEER_CIRCLE] },
    { id: "music", name: "Music & Worship", tagline: "Lifting voices in praise", description: "Our choirs, praise team, and musicians lead the congregation in joyful, Spirit-filled worship.", image: "https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?w=1600&q=85" },
    { id: "women", name: "Women's Missionary Society", tagline: "Women of faith in action", description: "Mission, prayer, and sisterhood — locally and globally.", image: WMS_PHOTO },
    { id: "house2house", name: "House²House Ministries", tagline: "Where Connection Becomes Community.", description: "Our fully online church — a complete Sunday worship experience, the preached Word, prayer, and Spirit-led fellowship gathered from wherever you are. The doors of Greater Mount Olive never close.", image: px(5970871) },
    { id: "lay", name: "Lay Organization", tagline: "The connectional church at work", description: "Equipping members for service, leadership, and engagement in AME connectional life.", image: REEL_DANCERS },
    { id: "sheame", name: "She AME", tagline: "Coming Soon · Faith. Sisterhood. Purpose.", description: "Coming soon — a new women's ministry of Greater Mount Olive AME Church. A sacred space where women of every season will grow together in faith, sharpen their leadership, and serve boldly. Sisterhood with substance. Watch this space.", image: SHE_AME_LOGO, contain: true, bgColor: "#FFF8E7" },
];

export const FEATURED = [
    {
        id: "f1",
        eyebrow: "This Sunday",
        title: "Worship in person at 11 AM",
        subtitle: "Doors open at 9:30 · Coffee · Welcome team",
        cta: "Plan Your Visit",
        href: "/contact#visit",
        image: PASTOR_PULPIT,
    },
    {
        id: "f2",
        eyebrow: "Now Open · Stewards & Tithers",
        title: "The Steward's Advantage",
        titleNode: <>The <i>Steward&rsquo;s</i> Advantage</>,
        subtitle: "A program for the faithful tither — wherever you worship.",
        cta: "Learn More",
        href: "/give#stewards",
        image: "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?w=1600&q=85",
    },
    {
        id: "f3",
        eyebrow: "Outreach",
        title: "Food Pantry · Open Weekly",
        subtitle: "Wednesdays · 9 – 11:30 AM · Call (215) 473-1747",
        cta: "Get Involved",
        href: "/ministries",
        image: HOME_FOOD_PANTRY,
    },
    {
        id: "f4",
        eyebrow: "Watch & Listen",
        title: "Catch the latest sermon",
        subtitle: "Stream every Sunday message — anytime, anywhere",
        cta: "Watch Sermons",
        href: "/sermons",
        image: REEL_GOLD_VESTMENT,
    },
];

export const GALLERY_STRIP = [
    PASTOR_PULPIT,
    REEL_ADVENT,
    BAPTISM,
    REEL_GOLD_VESTMENT,
    REEL_CHAPLAIN_AWARD,
    REEL_YPD_PASTOR,
    REEL_CHRISTMAS_KIDS,
    REEL_SCHOOL_KIDS,
    PASTOR_PARK,
    CHURCH_EXTERIOR,
    WMS_PHOTO,
];

export const SCRIPTURE = {
    text: "Sing to the Lord a new song. Praise Him in the assembly of His faithful people.",
    ref: "Psalm 149:1",
};

// Grateful Sponsors — simple alphabetical list of individuals & businesses who support the ministry.
// Edit this list to add, remove, or rename. Items re-sort alphabetically on render.
export const SPONSORS = [
    "Benjamin, R.",
    "Conway, B.",
    "Conway, S.",
    "Davis, E.",
    "Davis, M.",
    "Graves, L.",
    "Hundley, K.",
    "Senegar, C.",
];
